const FORM_SEND = 'EXPERIENCE_FORM_SEND';
const FORM_SEND_ERROR = 'EXPERIENCE_FORM_SEND_ERROR';
const FORM_SET_HAS_WORKING_EXPERIENCE = 'EXPERIENCE_FORM_SET_HAS_WORKING_EXPERIENCE';
const FORM_SET_SENDING = 'EXPERIENCE_FORM_SET_SENDING';


const experienceFormSend = ({
                              job,
                              employer,
                              dateFrom,
                              dateTo,
                              stillWorking,
                              userId,
                              hasWorkExperience,
                              countryId,
                              city
}) => ({
  type: FORM_SEND,
  payload: {
    job,
    employer,
    dateFrom,
    dateTo,
    stillWorking,
    userId,
    hasWorkExperience,
    countryId,
    city
  }
});

const experienceFormSendError = () => ({
  type: FORM_SEND_ERROR
});

const experienceFormSetHasWorkingExperience = (hasWorkExperience) => ({
  type: FORM_SET_HAS_WORKING_EXPERIENCE,
  payload: {
    hasWorkExperience
  }
});

const experienceFormSetSending = (sending) => ({
  type: FORM_SET_SENDING,
  payload: {
    sending
  }
});

export {
  FORM_SEND,
  FORM_SET_HAS_WORKING_EXPERIENCE,
  FORM_SET_SENDING,
  experienceFormSetSending,
  experienceFormSetHasWorkingExperience,
  experienceFormSend,
  experienceFormSendError
};
